import { render, staticRenderFns } from "./bay_window2.vue?vue&type=template&id=08a15b77&scoped=true"
import script from "./bay_window2.vue?vue&type=script&lang=js"
export * from "./bay_window2.vue?vue&type=script&lang=js"
import style0 from "./bay_window2.vue?vue&type=style&index=0&id=08a15b77&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08a15b77",
  null
  
)

export default component.exports